import { render } from "./ProjectEditWidget.vue?vue&type=template&id=216a51ae&ts=true"
import script from "./ProjectEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProjectEditWidget.ts?vue&type=script&lang=ts&external"

import "./ProjectEditWidget.vue?vue&type=style&index=0&id=216a51ae&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__